import React from 'react'
import { List, Datagrid, TextField } from 'react-admin'
// import LinkToRelatedPriorityLevel from './LinkToRelatedPriorityLevel'
import PriorityLevelActions from './Actions'

export const PriorityLevelList = props => (
    <List {...props}
        bulkActionButtons={false}
        actions={<PriorityLevelActions permissions={props.permissions}/>}>
        <Datagrid rowClick="edit">
            {/* <TextField source="id" /> */}
            <TextField source="name" />
            <TextField source="description" />
            {/* <LinkToRelatedPriorityLevel source='id' /> */}
            {/* <EditButton /> */}
        </Datagrid>
    </List>
);

export default PriorityLevelList